module.exports = __webpack_public_path__ + "static/media/W19-0084_Mobile_AW_Banner_FR.101d7713.jpg";